import useLoginWithVipps from './useLoginWithVipps'
export default useLoginWithVipps
